import { render, staticRenderFns } from "./ProdutosPaginar.vue?vue&type=template&id=d84c746a&scoped=true&"
import script from "./ProdutosPaginar.vue?vue&type=script&lang=js&"
export * from "./ProdutosPaginar.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosPaginar.vue?vue&type=style&index=0&id=d84c746a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84c746a",
  null
  
)

export default component.exports